import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../../../../assets/css/superadmin/dashboard/summary/Summary.css';

const StatusBadge = ({ status }) => (
  <span className={`dov-badge dov-badge-${status?.toLowerCase()}`}>{status}</span>
);

const Card = ({ children, className = '' }) => (
  <div className={`dov-card ${className}`}>{children}</div>
);

const CardHeader = ({ title, link, linkText, onLinkClick }) => (
  <div className="dov-card-header">
    <h2 className="dov-card-title">{title}</h2>
    {link && <button className="dov-view-all" onClick={onLinkClick}>{linkText || 'View All'}</button>}
  </div>
);

export default function DashboardOverview({ disputes = [], payouts = [], bookings = [], blogs = [] }) {
  const navigate = useNavigate();

  const recentDisputes = disputes.slice(0, 2);
  const recentPayouts = payouts.slice(0, 2);
  const recentBookings = bookings.slice(0, 2);
  const recentBlogs = blogs.slice(0, 2);

  return (
    <div className="dov-wrapper">
      <Container fluid className="dov-container">
        <Row className="dov-row g-4">

          {/* Recent Disputes */}
          <Col lg={6}>
            <Card>
              <CardHeader title="Recent Disputes" link linkText="View All" onLinkClick={() => navigate('/admin/disputes')} />
              <div className="dov-table-head">
                <span>USER</span>
                <span>ISSUE</span>
                <span>STATUS</span>
              </div>
              {recentDisputes.map((d) => (
                <div key={d.id} className="dov-dispute-row">
                  <div className="dov-user-cell">
                    <div className="dov-avatar">{d.avatar}</div>
                    <div>
                      <p className="dov-user-name">{d.name}</p>
                      <p className="dov-user-role">{d.role}</p>
                    </div>
                  </div>
                  <p className="dov-issue-text">{d.issue}</p>
                  <StatusBadge status={d.status} />
                </div>
              ))}
            </Card>
          </Col>

          {/* Recent Payouts */}
          <Col lg={6}>
            <Card>
              <CardHeader title="Recent Payouts" link linkText="View All" onLinkClick={() => navigate('/admin/payouts')} />
              <div className="dov-table-head dov-payout-head">
                <span>PAYOUT ID</span>
                <span>SELLER NAME</span>
                <span>AMOUNT</span>
              </div>
              {recentPayouts.map((p) => (
                <div key={p.id} className="dov-payout-row">
                  <span className="dov-payout-id">{p.id}</span>
                  <span className="dov-payout-seller">{p.seller}</span>
                  <span className="dov-payout-amount">{p.amount}</span>
                </div>
              ))}
            </Card>
          </Col>

          {/* Recent Bookings */}
          <Col lg={6}>
            <Card>
              <CardHeader title="Recent Bookings" link linkText="View All" onLinkClick={() => navigate('/admin/bookings')} />
              <div className="dov-table-head dov-booking-head">
                <span>BOOKING ID</span>
                <span>MACHINERY</span>
                <span>CUSTOMER</span>
              </div>
              {recentBookings.map((b) => (
                <div key={b.id} className="dov-booking-row">
                  <span className="dov-booking-id">{b.id}</span>
                  <div>
                    <p className="dov-mach-name">{b.machinery}</p>
                    <p className="dov-mach-sub">{b.sub}</p>
                  </div>
                  <span className="dov-booking-customer">{b.customer}</span>
                </div>
              ))}
            </Card>
          </Col>

          {/* Latest Blogs */}
          <Col lg={6}>
            <Card>
              <CardHeader title="Latest Blogs" link linkText="Manage Blogs" onLinkClick={() => navigate('/admin/blogs')} />
              <div className="dov-blogs-list">
                {recentBlogs.map((b, i) => (
                  <div key={i} className="dov-blog-row">
                    <img src={b.img} alt={b.title} className="dov-blog-thumb" />
                    <div className="dov-blog-info">
                      <span className="dov-blog-category">{b.category}</span>
                      <p className="dov-blog-title">{b.title}</p>
                    </div>
                    <FaChevronRight className="dov-blog-arrow" />
                  </div>
                ))}
              </div>
            </Card>
          </Col>

        </Row>
      </Container>
    </div>
  );
}